import { render } from "./PlayIcon.vue?vue&type=template&id=17f8befa"
const script = {}
script.render = render

export default script